export const help = {
  help: {
    title1: "Hello",
    title2: "May I ask if there is anything I can help you with",
    title3: "Recommended Reading",
    searchPlaceholder: "Please enter search content",
    list: [
      {
        name: "About Us",
        children: [
          {
            name: "Brand Introduction",
            type: 1,
          },
          {
            name: "Business cooperation",
            type: 2,
          },
        ],
      },
      {
        name: "Help Center",
        children: [
          {
            name: "Apply AiDaJuan",
            type: 3,
          },
          {
            name: "Account issues",
            type: 4,
          },
          {
            name: "Investigating issues",
            type: 5,
          },
          {
            name: "Exchange issues",
            type: 6,
          },
          {
            name: "Other issues",
            type: 7,
          },
        ],
      },
    ],
    content1: [
      {
        title1: "1.About AiDaJuan",
        pList: [
          {
            name: "1. Wide user participation: AiDaJuan provides an opportunity for netizens to participate in surveys and express their opinions. Any user can register and participate in various survey projects to express their views and opinions.",
          },
          {
            name: "2. Fun and Paid Survey Projects: AiDaJuan provides fun survey projects to make user participation more interesting and enjoyable. At the same time, users can also receive certain rewards by participating in the survey.",
          },
          {
            name: "3. Fast and effective communication channels: Provides a fast and effective communication channel between consumers and businesses. Consumers can directly provide feedback and suggestions to businesses, and businesses can also understand their needs and feedback through love quizzes.",
          },
          {
            name: "4. Professional level online market research: Love Answers has a professional team and technology, which can provide high-quality online market research services for enterprises. Through various survey methods and tools, help enterprises obtain accurate and comprehensive market information, and provide strong reference basis for enterprise decision-making.",
          },
        ],
      },
    ],
    content2: [
      {
        title1: "Contact us",
        pList: [
          {
            name: "If necessary, please contact us and we hope to have further communication and cooperation negotiations with you",
          },
          {
            name: "Email address: 123456789@163.com",
          },
        ],
      },
    ],
    content3: [
      {
        title1: "What is AiDaJuan?",
        pList: [
          {
            name: "AiDaJuan It is a professional market research website. Our questionnaire comes from companies and manufacturers around the world. When you answer a questionnaire, your perspective will be conveyed to businesses around the world to improve products, enhance services, and even create new products. To express our gratitude, we will reward you with coins for every participation in the survey. You can use them to exchange for cash, mobile recharge cards, shopping cards, and gifts.",
          },
        ],
      },
      {
        title1: "How to play AiDaJuan?",
        pList: [
          {
            name: "Playing to earn AiDaJuan is very simple, it only takes three steps",
          },
          {
            name: "Step 1: Register Step 2: Participate in the survey Step 3: Get rewards",
          },
        ],
      },
      {
        title1: "3. What to do when encountering problems?",
        pList: [
          {
            name: "Customer service email: member@baishulai.com",
          },
        ],
      },
      {
        title1: "How to register?",
        pList: [
          {
            name: "Step 1: When not logged in, click the 'Free Registration' button in the upper right corner of the homepage, and fill in the basic registration information on the registration page. The information must be true and valid.",
          },
          {
            name: "Step 2: Check your registered email and click on the activation link in the email to complete the registration.",
          },
        ],
      },
      {
        title1: "5. Precautions for the registration process.",
        pList: [
          {
            name: "A. The information filled in during registration must be accurate, otherwise prizes cannot be redeemed smoothly. For example, the date of birth must match the date of birth on the ID card; The city must match the IP address, etc",
          },
          {
            name: "B. The same computer cannot be registered multiple times.",
          },
          {
            name: "C. If you have not received the activation email after submitting the registration information:",
          },
          {
            name: "①Please verify if the phone number is correct.",
          },
          {
            name: "③Wait 1-2 minutes before checking the verification code.",
          },
          {
            name: "④If you do not receive the verification code within 5 minutes, please follow the WeChat public 'AiDaJuan' to explain the situation, and we will help you complete the registration.",
          },
        ],
      },
      {
        title1: "6. How is the membership level calculated?",
        pList: [
          {
            name: "Member level is linked to credit value. When registering, it defaults to being an iron brand member;",
          },
          {
            name: "Poor: When ≤ 60, it is an iron brand member;",
          },
          {
            name: "Moderate: 61 ≤ Credit value ≤ 100, is a bronze medal member;",
          },
          {
            name: "Good: 101 ≤ Credit value ≤ 200, silver membership;",
          },
          {
            name: "Excellent: 201 ≤ Credit value ≤ 500, gold medal member;",
          },
          {
            name: "Diamond: 501 ≤ Credit value ≤ 800, is a diamond member;",
          },
          {
            name: "King: 801 ≤ Credit value ≤ 1000, is a member of King;",
          },
          {
            name: "Member level benefits: There will be relative VIP exclusive activities based on different member levels.",
          },
        ],
      },
    ],

    content4: [
      {
        title1: "1.About Account Management Standards？",
        pList: [
          {
            name: "AiDaJuan is an online survey website that provides as many questionnaires as possible for members to participate in. It is a platform for everyone to participate in social market decision-making and express their personal opinions. If a member has not participated in any surveys or activities for more than 6 months, in order to avoid idle accounts, AiDaJuan has the right to revoke member accounts. Before recovering the account, AiDaJuan's customer service will notify you by email one month in advance. If you do not reply, we will assume that you have approved.",
          },
        ],
      },
      {
        title1: "2.What to do if I forget to log in information？",
        pList: [
          {
            name: "A. If you forget your password, click `Forget Password` and follow the prompts to retrieve it.",
          },
          {
            name: "B. To prevent forgetting your password again, go to `Account Settings` and find `Change Password` in `Security Settings` and change it to a commonly used password.",
          },
          {
            name: "C. Forget your account, follow the WeChat official account AiDaJuan, and send your commonly used email, mobile phone number, nickname and other information to the customer service to help you retrieve your account.",
          },
        ],
      },
    ],
    content5: [
      {
        title1:
          "Is it true that participating in business surveys can earn cash rewards？",
        pList: [
          {
            name: "Before launching a new product into the market, businesses usually conduct market research to understand consumer opinions. And merchants are willing to pay research fees for this, so participating in business surveys can indeed earn cash rewards. Of course, as a participant in the survey, all you need to do is answer questions truthfully based on your own situation and thoughts. After completing the survey, you can receive corresponding cash rewards. If the business survey is an immediate reward, you can receive the corresponding gold coin reward after completing the survey. Of course, if your answer sheet is later reviewed by our staff as unqualified, the reward given to you will be deducted back; So, it is important to answer the questionnaire seriously and truthfully. There are still a few special business investigation projects that require approval before rewards can be issued.",
          },
        ],
      },
      {
        title1:
          "How to participate in business surveys? How to know if there is a survey suitable for oneself to participate in？",
        pList: [
          {
            name: "A. Log in to the website and click on the `Survey Center` in the navigation section to check if there are any business surveys that you are suitable to participate in. If available, click on the survey title to participate.",
          },
          {
            name: "B. The most timely way: Log in to AiDaJuan every day and participate in surveys and activities in a timely manner.",
          },
          {
            name: "C. Please check our survey invitation email in your email and answer the questionnaire directly through the link in the email. Sometimes we also notify you to participate through SMS on your phone.",
          },
        ],
      },
      {
        title1:
          "3.Why do I join for a while but rarely receive survey invitations？",
        pList: [
          {
            name: "AiDaJuan releases new business surveys almost every day, but each survey has its own specific participation criteria, such as age, gender, region, income, and so on. So not every survey is suitable for you. We will only select surveys that meet your personal requirements and invite you to participate.",
          },
          {
            name: "Friendly reminder: The more detailed and truthful the personal information you fill in, the greater the opportunity to participate in business surveys. Completing mobile verification and email activation will also help you gain more business investigation opportunities.",
          },
        ],
      },
      {
        title1:
          "4.Why is it sometimes prompted to stop participating in business surveys after answering a few questions？",
        pList: [
          {
            name: "The business survey sent to you meets the basic information survey requirements you filled out when registering, but there will be additional screening criteria in the questionnaire. If you do not meet these screening criteria, you will be forced to suspend the investigation. In addition, each business survey has a limit on the number of participants, and it is possible that by the time you participate in the survey, the system has already collected enough questionnaires, which can also prevent you from continuing to participate in the survey. Although you were unable to complete the questionnaire, as a token of gratitude, the system will reward you with 10 coins.",
          },
        ],
      },
      {
        title1:
          "5.How much reward can one receive for completing a business survey？",
        pList: [
          {
            name: "The corresponding cash rewards may vary depending on the duration and conditions of each business survey questionnaire. Generally speaking, the cash reward for successfully completing a business survey questionnaire ranges from 5 to 50 yuan. If the investigation is suspended due to unsatisfactory conditions or full staff, as a token of gratitude, a reward of 10 gold coins will also be given.",
          },
        ],
      },
      {
        title1:
          "6.When will the rewards for participating in business surveys be distributed？",
        pList: [
          {
            name: "The rewards for business investigation are divided into two types: immediate rewards and review rewards. For instant reward business surveys, as long as you successfully complete the survey, you will receive rewards (the change in coin balance will be seen after you log in again); For commercial survey projects that require rewards for review, they need to be manually reviewed and confirmed to be qualified before being uniformly distributed and distributed by our staff. This cycle takes approximately 15-30 days. But rest assured, as long as you complete the survey seriously and effectively, our system will have records and gold coins will definitely reward you. Please be patient and wait.",
          },
        ],
      },
      {
        title1:
          "7.Why did I not receive a reward despite completing a business investigation？",
        pList: [
          {
            name: "As long as you answer and fill out the questionnaire seriously and honestly, please don't worry. After each survey is completed, we will compile a list of users who have not been able to earn points normally and carry out additional gold coin operations.",
          },
        ],
      },
      {
        title1:
          "8. Precautions during the questionnaire answering process: Violation of rules may result in deduction of rewards or even account closure.",
        pList: [
          {
            name: "A. The answering time is too short, for example, reading a questionnaire takes 10 minutes, but it takes only 3 minutes to complete.",
          },
          {
            name: "B. The information filled in the personal profile is inconsistent with the answers in the questionnaire.",
          },
          {
            name: "C. Not answering seriously, not reading questions, and filling in answers randomly.",
          },
          {
            name: "D. Those who answer multiple times for the same IP and IP segment are considered cheating.",
          },
          {
            name: "E. There are clear signs that the same person repeatedly answered, which is considered cheating.",
          },
          {
            name: "A questionnaire survey is serious, and only genuine perspectives can contribute to market research. We have the right to deduct the illegally obtained coins from those who encounter the above circumstances. If the situation is serious, we will delete the account.",
          },
        ],
      },
      {
        title1:
          "9. Why will completed questionnaires be reviewed later and not meet the requirements, resulting in points being deducted？",
        pList: [
          {
            name: "In every survey, respondents should answer the questionnaire in a serious, honest, and trustworthy manner. After the questionnaire survey is completed and data collection is completed, our clients will review each piece of data collected. If any careless or dishonest answering behavior is found, customers will invalidate this data. Therefore, in the future, we will also deduct the rewards obtained from the invalidated data from the corresponding user's account. In severe cases, we will double the rewards or blacklist or even delete the user's account. The principles of data invalidation include, but are not limited to, the following situations: filling out open-ended questions randomly, answering questionnaires with careless and contradictory logic, illogical logic, short answer times that do not meet the questionnaire requirements, identical answer data, and any other possible cheating and brushing methods.",
          },
        ],
      },
      {
        title1: "10.What are the reasons for the failure of task review？",
        pList: [
          {
            name: "1、Same data: The answers to different questions from the same user are identical, or the similarity of answers from multiple users is extremely high.",
          },
          {
            name: "2、Poor quality of open-ended questions: random responses, incorrect answers, etc., resulting in data unavailability.",
          },
          {
            name: "3、Poor answer quality: Answering randomly on closed questions with unavailable data.",
          },
          {
            name: "4、Inconsistent logic before and after: During the answering process, there was a clear contradiction in the answers before and after. For example, the previous statement stated that they had purchased milk within 3 months, while the latter replied that they had not purchased milk recently.",
          },
          {
            name: "PS: The above behaviors will result in you not being able to receive rewards, and in severe cases, you will also be blacklisted; In addition, if we find that users are suspected of technical cheating, we may take legal measures to pursue legal action.",
          },
        ],
      },
    ],
    content6: [
      {
        title1: "1.WeChat red envelope redemption rules。",
        pList: [
          {
            nameFa: "Rules for redeeming 5 yuan WeChat red envelopes",
            name: "10 yuan WeChat red envelope/30 yuan WeChat red envelope/50 yuan WeChat red envelope/100 yuan WeChat red envelope ",
          },
          {
            name: "1. Only through the AiDaJuan WeChat official account, please follow the AiDaJuan WeChat official account.",
          },
          {
            name: "2. The redeemed red envelope will be distributed to your WeChat account in the form of a red envelope. If the red envelope is not claimed within 24 hours, the system will automatically retrieve the red envelope and return the coins to your AiDaJuan account.",
          },
          {
            name: "3. The final interpretation rights belong to AiDaJuan",
          },
        ],
      },
      {
        title1: "2. Exchange rules of Alipay.",
        pList: [
          {
            name: "1. You need to improve Alipay information.",
          },
          {
            name: "2. Alipay orders are reviewed and issued every Friday.",
          },
          {
            name: "3. The final interpretation rights belong to AiDaJuan",
          },
        ],
      },
    ],
    content7: [
      {
        title1: "1. Contact us",
        type: 1,
        pList: [
          {
            name: "AiDaJuan Community Address：<a href='http://test.aidajuan.com/home'>http://test.aidajuan.com/home</a><br/>Follow the WeChat official account and reply questions faster:<br/><img src='http://www.sudiaoba.com/images/erw.jpg' /><br>Customer service email: member@baishulai.com",
          },
        ],
      },
      {
        title1: "2. Website Map",
        type: 1,
        pList: [
          {
            name: "<a href='http://test.aidajuan.com/register'>Register</a> | <a href='http://test.aidajuan.com/login'>Login</a> | <a href='http://test.aidajuan.com/home'>Home</a> | <a href='http://test.aidajuan.com/module/task'>Task</a> | <a href='http://test.aidajuan.com/module/exchange'>Integral</a> | <a href='http://test.aidajuan.com/module/activity'>Activity</a> | <a href='http://test.aidajuan.com/module/help'>Help</a> | <a href='http://test.aidajuan.com/commerce'>Commerce</a> | <a href='http://test.aidajuan.com/module/home'>My Home</a> | <a href='http://test.aidajuan.com/module/taskRecord'>Task list</a> | <a href='http://test.aidajuan.com/module/redemptionHistory'>Exchange</a> | <a href='http://test.aidajuan.com/module/goldHistory'>Gold coins</a> | <a href='http://test.aidajuan.com/module/account'>Account</a> | <a href='http://test.aidajuan.com/module/invite'>My Invite</a> | <a href='http://test.aidajuan.com/module/creditValue'>Credit value</a>",
          },
        ],
      },
      {
        title1: "3. Registration Agreement",
        pList: [
          {
            name: "[Prudent Reading] Before clicking to agree to this agreement during the registration application process, you should carefully read this agreement. Please carefully read and fully understand the contents of each clause, especially the relevant clauses on usage instructions, privacy protection, and legal responsibility. If you have any questions about the agreement, you can consult AiDaJuan customer service. AiDaJuan belongs to Nanjing Baishulai Information Technology Co., Ltd. and is a professional market research website. User registration, login, and use of AiDaJuan and related products shall be deemed as acceptance of this agreement and agreement to be bound by the terms of this agreement.",
          },
          {
            name: "Registration instructions",
          },
          {
            name: "Users must fully agree to all the following service terms and complete the registration process in order to become members of AiDaJuan. Unless otherwise specified, all new products related to AiDaJuan shall unconditionally comply with this agreement. ",
          },
          {
            name: "Service content",
          },
          {
            name: "After becoming an official member of AiDaJuan, users will receive survey questionnaires irregularly. Members can participate in the questionnaire by logging in to AiDaJuan. AiDaJuan will also periodically contact users via email and invite members to participate in various forms of market research. Members can exchange AiDaJuan's gold coin rewards for prizes.",
          },
          {
            name: "Personal account management",
          },
          {
            name: "1. AiDaJuan's registered users have the obligation to properly keep and use the account and password obtained during the registration service, and are responsible for the series of actions or activities that begin after logging into the system with this account and password.",
          },
          {
            name: "2. Users should not disclose or provide third-party knowledge, lend or transfer their accounts and passwords to others for use. If the account or password is leaked due to the user's own fault or negligence, causing losses to the user, the user should bear the responsibility on their own.",
          },
          {
            name: "3. If a user discovers that their account or password has been illegally or abnormally used by others, they should immediately notify AiDaJuan and submit relevant proof that the account belongs to them, in order to apply for the suspension of the account. The losses caused as a result, AiDaJuan shall not be liable for compensation.",
          },
          {
            name: "4. AiDaJuan members are obligated to strictly fill in account information according to their actual situation. If any account information is found to be inconsistent with the actual situation, AiDaJuan has the right to suspend or terminate the user's account and refuse all or part of the current or future use of the service.",
          },
          {
            name: "5. AiDaJuan members are not allowed to register multiple accounts at the same time, AiDaJuan will conduct technical inspections through various technical means. When multiple accounts are found, AiDaJuan has the right to suspend the account.",
          },
          {
            name: "6. After registering an AiDaJuan account, if the user does not use it for a long time, AiDaJuan has the right to delete their account to avoid wasting resources.",
          },
          {
            name: "User Instructions",
          },
          {
            name: "Users are especially reminded that the use of the Internet must comply with relevant national policies and laws, such as criminal law, national security law, confidentiality law, and computer information system security protection regulations, to protect national interests; Protecting national security. Users shall be fully and jointly liable for all liabilities arising from illegal or improper use of the Internet.",
          },
          {
            name: "1. Users are not allowed to use AiDaJuan to send or disseminate sensitive information or information that violates national laws and regulations; Users are not allowed to use AiDaJuan to send or disseminate false, harassing, insulting, threatening, harmful, provocative, vulgar, obscene or pornographic information.",
          },
          {
            name: "2. AiDaJuan, like most internet websites or applications, is vulnerable to various security issues, including personal data theft, exploitation by criminals, and harassment in real life; Password cracked; Other software or files downloaded and installed contain various viruses that threaten the security of information and data on personal computers, thereby threatening the use of AiDaJuan. ",
          },
          {
            name: "3. Users should strengthen their awareness of personal data protection to avoid unnecessary impacts on their personal life and normal use of AiDaJuan services.",
          },
          {
            name: "4. Stealing other people's user accounts, sharing and disseminating illegal and harmful information and files, or using network communication to harass others are all illegal behaviors.",
          },
          {
            name: "5. Violation of rules and punishment regulations. (1) I did not participate in the survey seriously and did not truthfully fill out the questionnaire according to my own wishes. I will be penalized with a gold coin deduction based on the amount of gold coins in each questionnaire.",
          },
          {
            name: "6. The principle of questionnaire confidentiality must be followed. AiDaJuan members must strictly abide by the principle of investigation confidentiality, and are not allowed to post or share answers, copy questionnaire content, or make any prompts for others. Once discovered, they will be held legally responsible.",
          },
          {
            name: "7. The registration information is true and accurate. Users should ensure that the information they provide to AiDaJuan is true and accurate, and must not forge or use other people's information for registration. This information is crucial for using AiDaJuan's services and redeeming various prizes and cash. Any losses caused by users providing false information or being informed of their registration information by others shall be borne by the users themselves.",
          },
          {
            name: "Privacy protection",
          },
          {
            name: "1.After the member successfully registers, AiDaJuan will store the information provided by members in our secure database. The personal information of members will be used to ensure that the proportion of questionnaire participants is representative of the total population, and to identify the most suitable candidates for specific survey projects.",
          },
          {
            name: "2.AiDaJuan will not disclose the member's personally identifiable information without the member's consent, and will not collect personal information or disclose the member's personal information to others through online surveys or invitations.",
          },
          {
            name: "3. After joining AiDaJuan, members will default to, AiDaJuan and its partners have the right to contact members through contact information provided by members via email, text message, phone, etc. when needed (such as inviting members to participate in surveys or paying prizes to members). However, due to the non absolute security of the network, we will do our best to use technological means to protect your personal information, but we cannot guarantee its absolute security.",
          },
          {
            name: "4.The member information collected by AiDaJuan is part of online surveys and research. These data will be comprehensively analyzed and transmitted in the form of collective or statistical reports to the companies conducting the survey. The data collected from each survey questionnaire is only for the purpose of conducting one study, and there is absolutely no forwarding or online dissemination related to third parties!",
          },
          {
            name: "5.By participating in an online questionnaire survey, the member acknowledges and agrees to use their personal information (such as the member's answers in the questionnaire and the provided name, email address, etc.) for market research, market analysis, internal management, internal training, etc., and agrees to fulfill the AiDaJuan User Agreement. The contact information of AiDaJuan members can only be used to invite members to participate in surveys, confirm the authenticity of the information provided by members, or provide members with information related to payment bonuses. Members can only be contacted by email, text message, or phone. Members participating in AiDaJuan's activities are voluntary and have the right to choose to join or exit.",
          },
          {
            name: "6. Participating in AiDaJuan's investigation indicates that you have agreed to our processing of member personal information and disclosure of such information to other companies in compliance with the above privacy protection regulations, as well as that you are a Chinese citizen aged 14 or above.",
          },
          {
            name: "7.To protect children, AiDaJuan has no intention of inviting children to join the membership. If children are required to participate in the survey, they must be supervised by adults and answer the relevant questions of the questionnaire according to their own wishes.",
          },
          {
            name: "Legal Liability",
          },
          {
            name: "1.We assume no responsibility for the accuracy, content, completeness, legality, reliability, operability, or availability of the information or materials displayed in AiDaJuan. We do not assume any responsibility for the deletion, storage failure, incorrect provision or untimely provision of any information or materials in AiDaJuan. We do not guarantee the safety, reliability, timeliness, or performance of AiDaJuan. We do not guarantee any information or advice obtained through AiDaJuan.",
          },
          {
            name: "2. The user understands and agrees that obtaining information or data through AiDaJuan is solely based on their own judgment and at their own risk. They will also be fully responsible for any computer system damage or data loss caused by downloading such materials or data. Except for the service terms specified in the AiDaJuan terms, this website shall not be liable for any accidents, negligence, contract damage, defamation, copyright or other intellectual property infringement or losses caused by the use of AiDaJuan (including computer virus infection due to downloading).",
          },
          {
            name: "3. The user understands and agrees that in the feedback processing service, AiDaJuan's customer service and related staff are not professionals and can only judge the credentials submitted by users based on the knowledge of ordinary people. Therefore, except for intentional acts, AiDaJuan is exempt from liability for the decision.",
          },
          {
            name: "4. AiDaJuan shall assume basic protection obligations in accordance with the law, but shall not be liable for any damages caused to you due to maintenance or connection failures of information network equipment, computer, communication or other system failures, power failures, strikes, riots, fires, floods, storms, explosions, wars, government actions, orders from judicial administrative agencies, or third-party reasons.",
          },
          {
            name: "5. If any unit or individual believes that the content of AiDaJuan may be suspected of infringement, they should prepare legal proof materials and contact AiDaJuan in a timely manner so that AiDaJuan can take prompt action.",
          },
          {
            name: "6. The comments of AiDaJuan members are purely personal opinions, and the purpose of posting on the website is to convey more information. It does not mean that AiDaJuan agrees with their views and is responsible for their authenticity, AiDaJuan does not assume any legal responsibility arising from this.",
          },
          {
            name: "7. Anyone who logs in to AiDaJuan in any way or directly or indirectly uses AiDaJuan data shall be deemed to have voluntarily accepted the terms and conditions of this agreement. Any issues not covered by this statement can be found in relevant national laws and regulations. In case of any conflict between this statement and national laws and regulations, the latter shall prevail.",
          },
          {
            name: "Agreement modification and others",
          },
          {
            name: "1.The interpretation and modification rights of the above agreement terms belong to AiDaJuan. ",
          },
          {
            name: "2.AiDaJuan reserves the right to modify this user agreement at any time and encourages you to regularly check for updates. If members do not agree to the modification of the service agreement terms, they can proactively contact us or stop using the services provided by AiDaJuan and its related products; If the user continues to use AiDaJuan and its related products, it shall be deemed that the user has accepted the modification of the service agreement terms. ",
          },
          {
            name: "3. The terms of this agreement and the other service terms of AiDaJuan constitute the entire agreement. The provisions of this agreement are partially invalid due to conflicts with the current laws of the People's Republic of China, and shall not affect the validity of other parts.",
          },
        ],
      },
      {
        title1: "4.Privacy Policy",
        type: 1,
        pList: [
          {
            name: "Dear user, please make sure to carefully read the AiDaJuan (hereinafter referred to as 'we') policy statement and make sure to understand our rules for handling your personal information. Please make sure to fully understand the contents of each clause, especially the clauses that are highlighted in bold, underlined, and other forms.",
          },
          {
            name: "Unless you have fully read, fully understood, and accepted all terms of this privacy policy, you have no right to use our products or services. If you click 'Agree' or 'Next', or if you use our products or services, or express or imply acceptance of this privacy policy in any other way, it is deemed that you have read and agreed to sign this privacy policy. This privacy policy shall have legal effect between you and us and become a binding legal document for both parties.",
          },
          {
            name: "If you do not have full civil capacity due to factors such as age and intelligence, please read and judge whether you agree to this privacy policy with the legal guardian (hereinafter referred to as the 'guardian'), and pay special attention to the terms of use for minors.",
          },
          {
            name: "If you are a user outside Chinese Mainland, you must also abide by the laws of your country or region when entering into or performing this agreement.",
          },
          {
            name: "AiDaJuan attaches great importance to user privacy and personal information protection. We may collect and use your relevant information when you use our products and/or services. We would like to explain to you through our Privacy Policy how we collect, use, store, share, and transfer this information when you use our products and/or services.",
          },
          {
            name: "This policy will help you understand the following content:",
          },
          {
            name: "1. How do we collect your personal information",
          },
          {
            name: "2. How do we use cookies and similar technologies",
          },
          {
            name: "3. How do we use your personal information",
          },
          {
            name: "4. How will we share, transfer, and publicly disclose your personal information",
          },
          {
            name: "5. How do we protect and save your personal information",
          },
          {
            name: "6. How do you manage personal information",
          },
          {
            name: "7. Protection of underage information",
          },
          {
            name: "8. Application and updates of this policy",
          },
          {
            name: ". How to contact us",
          },
          {
            name: "How do we collect your personal information",
          },
          {
            name: "Personal information refers to various types of information recorded electronically or in other ways that can individually or in combination with other information identify the identity of a specific natural person or reflect the activities of a specific natural person. The personal information involved in this privacy policy includes：<strong>Basic information</strong>（Including personal name, birthday, gender, address, phone number, email address）；<strong>Personal Identity Information</strong>（Including ID card, military officer certificate, passport, driver's license, etc）；<strong>Demographic attribute information</strong>（Education level, occupation, income, and other information that needs to be collected for market research industries）；<strong>Questionnaire response information</strong>（When participating in a market research questionnaire, you need to answer the questions in the questionnaire. You may need to provide the following but not limited to your daily information（Product cognition, consumer behavior, etc）；<strong>Personal property information</strong>（Points, prizes, point records, redemption records, and other information）；<strong>Personal internet records</strong>（Including website browsing records, software usage records, and click records）；<strong>Personal frequently used device information</strong>（Including hardware model, device MAC address IP address, operating system type, browser information, software list unique device identification code（Like IMEI Information describing the basic situation of personal commonly used devices, including IDFA, etc）；<strong>Personal location information</strong>（Accurate positioning information, longitude and latitude, etc）； ",
          },
          {
            name: "1. The information you provided directly",
          },
          {
            name: "(1)Register",
          },
          {
            name: "When registering an account or using the software services, you need to provide your nickname, profile picture, phone number, password, birthday, gender, province, and city. If you do not provide the aforementioned information, you may not be able to register an account or use this software service. A mobile phone number and password are necessary conditions for you to log in and use this software. Birthday, gender, province, and city information are necessary conditions for you to participate in market survey questionnaire sampling.",
          },
          {
            name: "Demographic attribute information is a necessary prerequisite for your participation in market research questionnaires. Therefore, in addition to registration information, you also need to provide us with the following attribute information, including but not limited to your education level, occupation, income, and other information that needs to be collected by market research industries.",
          },
          {
            name: "(2)Questionnaire answering",
          },
          {
            name: "A market survey questionnaire is a scientific method used to systematically collect, record, organize, and analyze information and materials related to the market, in order to understand the current situation and trends of market development and changes, and provide scientific basis for enterprise business decision-making, advertising planning, and advertising writing. A comprehensive questionnaire usually consists of the following parts:",
          },
          {
            name: "a. The basic information of the respondents includes their age, gender, education level, occupation, address, income, etc. ",
          },
          {
            name: "b. The survey content itself refers to the specific items being investigated, and it is the most important component of the questionnaire.",
          },
          {
            name: "c. The survey questionnaire mainly includes the purpose and requirements of filling out the form, precautions for the respondents, and submission time.",
          },
          {
            name: "The survey content is mainly filled out by users. For example, may I ask which brands of toothpaste have you used?",
          },
          {
            name: "A double-sided needle B Colgate C Yazhi ",
          },
          {
            name: "(3)Exchange",
          },
          {
            name: "We will first verify the legality of your points, such as whether there have been cases of cheating, theft, impersonation, or repeated collection of points. If any abnormal points are found, we have the right to refuse your redemption application and deduct the points you illegally obtained.",
          },
          {
            name: "1.When you exchange points for prizes, you are required to provide corresponding information based on the difference in prizes. Firstly, to redeem, it is necessary to verify the authenticity of your phone number in order to notify you of the relevant information. To redeem virtual prizes such as coupons, you need to provide email information so that you can receive card number/password information. To exchange cash prizes, you need to fill in Alipay, ID card, real name, and verify the ID card, because we need to declare your personal income tax to the tax authority.<strong>Please be aware that our personal income tax declaration to the tax authorities will be directly reflected in your personal income tax records. If you are receiving subsistence allowances or your income/personal income tax records are related to other matters, please be cautious in your operation to avoid unnecessary trouble. We do not assume any personal losses or responsibilities caused by this.</strong>or physical express delivery prizes, at least you need to provide your mobile phone number, recipient name, and delivery address information. ",
          },
          {
            name: "2. Automatically collected information",
          },
          {
            name: "In order to improve and enhance our products and services, and to provide you with more targeted and accurate market research activities, as well as meet the requirements of market research projects, you agree and authorize us to collect the following information from you：<strong>Personal internet records</strong>（Including website browsing records, software usage records, and click records）；<strong>Personal frequently used device information</strong>（Including hardware model, device MAC address IP address, operating system type, browser information, software list unique device identification code（Like IMEI Information describing the basic situation of personal commonly used devices, including IDFA, etc）；<strong>Personal location information</strong>（Accurate positioning information, longitude and latitude, etc）； ",
          },
          {
            name: "3. Third party information",
          },
          {
            name: "You may use Weibo, WeChat When a third party account such as QQ Alipay logs in to the software, we may obtain your authorized account information (ID, avatar, nickname, etc.) from a third party, and bind your third party account with your software account after you agree to this privacy policy, so that you can directly log in and use our products and/or services through the third party account. We will use your personal information in accordance with relevant laws and regulations after confirming the legality of the source of personal information in accordance with agreements with third parties.",
          },
          {
            name: "How do we use cookies and similar technologies",
          },
          {
            name: "When you use our services, we store small data files called cookies on your computer or mobile device. We mainly use cookies in the following situations:",
          },
          {
            name: "1. Determine the login status of registered users",
          },
          {
            name: "2. Improve service/product quality and provide you with personalized needs",
          },
          {
            name: "3. Market survey questionnaire project requirements",
          },
          {
            name: "We will not use cookies for any purpose other than those stated in this policy. You can manage or delete cookies according to your preferences. You can clear all cookies saved on your computer, and most web browsers have a feature to block cookies.",
          },
          {
            name: "How do we use your personal information",
          },
          {
            name: "1. When using our services, it is used for identity authentication, user service, and security measures;",
          },
          {
            name: "2. Personalized services and helping us design new services to enhance our existing service experience; ",
          },
          {
            name: "3.market research、<strong>Advertising monitoring analysis and related</strong>Data research and analysis;",
          },
          {
            name: "4. Daily operational activities;",
          },
          {
            name: "5. Report to relevant departments in accordance with laws, regulations or regulatory requirements.",
          },
          {
            name: "How will we share, transfer, and publicly disclose your personal information",
          },
          {
            name: "1. Sharing",
          },
          {
            name: "We will not provide your personal information to third parties without your consent or authorization. However, with your confirmation and consent, we may share your personal information under the following circumstances.",
          },
          {
            name: "(1) Obtain your explicit consent or authorization in advance;",
          },
          {
            name: "(2) Provided in accordance with applicable laws and regulations, legal procedures, and mandatory administrative or judicial requirements;",
          },
          {
            name: "(3) Only by sharing your information can we achieve the core functions of our products and/or services or provide the services you need;",
          },
          {
            name: "(4) Handle disputes or controversies between you and others according to your needs; ",
          },
          {
            name: "(5) Used based on academic research;",
          },
          {
            name: "Sharing with our affiliated companies: Within the scope of the purposes stated in this policy statement, your personal information may be shared with our affiliated companies. As a policy, we will only share necessary information. If affiliated companies want to change the purpose of processing personal information, they will seek your authorization and consent again.",
          },
          {
            name: "We may share some of your information with partners and other third parties，<strong>Share your unique device identification code with third-party advertising monitoring service providers for market research, advertising monitoring analysis, etc.</strong>We will only process your personal information for specific, clear, and legal purposes, and will only share information necessary for providing services. At the same time, we will sign strict confidentiality agreements with them, requiring them to handle personal information in accordance with our instructions, this policy, and any other relevant confidentiality and security measures.",
          },
          {
            name: "2. Transfer",
          },
          {
            name: "We will not transfer your personal information to any company, organization, or individual, except in the following circumstances:",
          },
          {
            name: "(1) Transfer with explicit consent: After obtaining your explicit consent, we will transfer your personal information to other parties;",
          },
          {
            name: "(2) When it comes to mergers, acquisitions, or bankruptcy liquidation, if it involves the transfer of personal information, we will require the new company or organization that holds your personal information to continue to be bound by this privacy policy. Otherwise, we will require the company or organization to seek your authorization and consent again. ",
          },
          {
            name: "3. Public disclosure",
          },
          {
            name: "We will only publicly disclose your personal information under the following circumstances, provided that we take legal and industry standard security measures",
          },
          {
            name: "(1) Obtain your explicit consent;",
          },
          {
            name: "(2) Based on legal regulations, legal procedures, litigation, or mandatory requirements from government regulatory authorities. But we guarantee that, under the premise of complying with laws and regulations, when we receive the request for disclosure of information mentioned above, we will require the corresponding legal documents to be issued.",
          },
          {
            name: "How do we protect and save your personal information",
          },
          {
            name: "We value personal information security. We adopt standard practices in the Internet industry to protect your personal information from unauthorized access, disclosure, use, modification, damage or loss. We will take all reasonable and feasible measures to protect your personal information.",
          },
          {
            name: "We will try our best to protect your personal information, but please understand that due to technical restrictions and possible malicious means, it is impossible to always guarantee 100% security of information in the Internet industry. You need to understand that the system and communication network you use to access our services may encounter issues due to factors beyond our control.",
          },
          {
            name: "In the event of a personal information security incident, we will promptly inform you in accordance with the requirements of laws and regulations: the basic situation and possible impact of the security incident, the disposal measures we have taken or will take, suggestions for you to independently prevent and reduce risks, and remedial measures for you. We will promptly inform you of the relevant situation of the event through email, letter, phone, push notifications, and other means. If it is difficult to inform the personal information subject one by one, we will take reasonable and effective measures to publish an announcement.",
          },
          {
            name: "We will only keep your personal information for the necessary time frame to achieve the purposes stated in this policy. However, in order to comply with applicable laws and regulations, court judgments or rulings, requirements of other competent authorities, and to safeguard the public interest, we may extend the retention time of personal information appropriately.",
          },
          {
            name: "How do you manage personal information",
          },
          {
            name: "We will do everything possible to take appropriate technical measures to ensure the accuracy of the personal information collected about you and ensure timely updates.",
          },
          {
            name: "1、PC end, after logging stay<strong>Account Settings </strong>The following three types of information can be modified in: account information, personal information, and redemption information.",
          },
          {
            name: "2、Mobile end, after logging in,stay<strong>My</strong>You can modify various personal information inside. ",
          },
          {
            name: "Protection of information on minors",
          },
          {
            name: "1、If you are a minor under the age of 18, you should obtain written consent from your parent or legal guardian before using our products and/or services. We protect the personal information of minors in accordance with relevant national laws and regulations.",
          },
          {
            name: "2、For the collection of personal information of minors with the consent of parents or legal guardians, we will only use or publicly disclose this information when permitted by law, explicitly agreed by parents or guardians, or necessary to protect minors. If your guardian disagrees with your use of our services or provision of information to us in accordance with this policy, please immediately terminate your use of our services and notify us promptly so that we can take appropriate measures.",
          },
          {
            name: "Application and updates of this policy",
          },
          {
            name: "All services of this product are subject to policy regulations.",
          },
          {
            name: "We will update this policy in a timely manner when the following significant changes occur: ",
          },
          {
            name: "(1) Our basic situation has changed, such as changes in ownership caused by mergers, acquisitions, or reorganizations;",
          },
          {
            name: "(2) Changes in the scope, purpose, and rules of collecting, storing, and using personal information;",
          },
          {
            name: "(3) The object, scope, and purpose of providing personal information to the public have changed;",
          },
          {
            name: "(4) The way you access and manage personal information has changed; ",
          },
          {
            name: "(5) Changes in data security capabilities and information security risks; ",
          },
          {
            name: "(6) The channels and mechanisms for user inquiries and complaints, as well as external dispute resolution agencies and contact information, have changed; ",
          },
          {
            name: "(7) Other changes that may have a significant impact on your personal information rights.",
          },
          {
            name: "For significant policy changes, we will send you change notifications through different channels, including but not limited to website announcements, private message notifications App push and other methods.",
          },
          {
            name: "How to contact us",
          },
          {
            name: "When you have any questions about this policy, you can send an email to team # baisulai.com for consultation (please replace the # sign with the @ symbol), and we will promptly resolve your issue.",
          },
          {
            name: "<small>Note: This version of the Privacy Policy came into effect on January 1, 2019.</small>",
          },
        ],
      },
    ],
  },
};
export const help2 = {
  list: [
    {
      name: "Brand Introduction",
      children: help.help.content1,
    },
    {
      name: "Business cooperation",
      children: help.help.content2,
    },
    {
      name: "Apply AiDaJuan",
      children: help.help.content3,
    },
    {
      name: "Account issues",
      children: help.help.content4,
    },
    {
      name: "Investigating issues",
      children: help.help.content5,
    },
    {
      name: "Exchange issues",
      children: help.help.content6,
    },
    {
      name: "Other issues",
      children: help.help.content7,
    },
  ],
};
